import React, { useRef, useState } from 'react';

const DragDropUploader = ({ onFileSelect, accept, maxFileSize, label }) => {
    const fileInputRef = useRef(null);
    const [dragActive, setDragActive] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files?.[0]) {
            handleFile(e.dataTransfer.files[0]);
        }
    };

    const handleChange = (e) => {
        e.preventDefault();
        if (e.target.files?.[0]) {
            handleFile(e.target.files[0]);
        }
    };

    const handleFile = (file) => {
        if (maxFileSize && file.size > maxFileSize) {
            alert("File is too large!");
            return;
        }
        setSelectedFile(file);
        if (onFileSelect) {
            onFileSelect(file);
        }
    };

    const onButtonClick = () => {
        fileInputRef.current.click();
    };

    return (
        <div style={{ width: '100%' }}>
            {label && <label className="mb-3 d-block" style={{ fontWeight: '500' }}>{label}</label>}
            
            <button
                type="button"
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
                style={{
                    border: dragActive ? '2px dashed #2196F3' : '2px dashed #d1d5db',
                    borderRadius: '8px',
                    padding: '40px 20px',
                    textAlign: 'center',
                    backgroundColor: dragActive ? '#f0f8ff' : '#ffffff',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    width: '100%',
                    display: 'block'
                }}
                onClick={onButtonClick}
            >
                <input 
                    ref={fileInputRef}
                    type="file" 
                    accept={accept}
                    style={{ display: 'none' }} 
                    onChange={handleChange}
                />
                
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <i className="pi pi-images mb-3" style={{ fontSize: '2.5rem', color: '#2196F3' }}></i>
                    
                    {selectedFile ? (
                        <div>
                            <h6 style={{ margin: 0, color: '#333' }}>{selectedFile.name}</h6>
                            <small style={{ color: '#6b7280' }}>{(selectedFile.size / 1024 / 1024).toFixed(2)} MB</small>
                            <div className="mt-2 text-primary" style={{ fontSize: '0.85rem' }}>Click or drag to replace</div>
                        </div>
                    ) : (
                        <>
                            <div style={{ fontSize: '1rem', color: '#4b5563', marginBottom: '8px' }}>
                                <strong>Drag & Drop</strong> or <span style={{ color: '#2196F3' }}>browse</span>
                            </div>
                            <div style={{ fontSize: '0.8rem', color: '#9ca3af' }}>
                                Supports: JPEG, JPG, PNG, PDF
                            </div>
                        </>
                    )}
                </div>
            </button>
        </div>
    );
};

export default DragDropUploader;
